import ApplicationSerializer from './application';

export default class HomeScreenSerializer extends ApplicationSerializer {
  normalizeResponse(
    ...args: Parameters<ApplicationSerializer['normalizeResponse']>
  ) {
    if (Array.isArray(args[2])) {
      args[2] = { home_screens: args[2] };
    }

    return super.normalizeResponse(...args);
  }
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'home-screen': HomeScreenSerializer;
  }
}
